/* Dessin au trait révélé au scroll (figure-mythos). Les chemins se tracent l'un
   après l'autre, à la vitesse du scroll, comme une plume qui suit la lecture :
   le contour d'abord (chemin le plus long), les écailles ensuite. Une fois le
   dessin complet, il reste. prefers-reduced-motion : dessin complet d'emblée. */
(function () {
  if (window.mythosDrawing) return;
  window.mythosDrawing = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = [];
  var ticking = false;

  function setup(el) {
    if (el.dataset.drawingReady) return;
    el.dataset.drawingReady = '1';
    var paths = Array.prototype.slice.call(el.querySelectorAll('path'));
    if (!paths.length || reduce) { el.classList.add('is-drawn'); return; }
    var total = 0;
    var meta = paths.map(function (p) { var l = p.getTotalLength(); total += l; return { p: p, l: l }; });
    if (!total) { el.classList.add('is-drawn'); return; }
    var acc = 0;
    meta.forEach(function (m) {
      m.a = acc / total; m.b = (acc + m.l) / total; acc += m.l;
      m.p.style.strokeDasharray = m.l + ' ' + (m.l + 2);
      m.p.style.strokeDashoffset = m.l;
    });
    items.push({ el: el, svg: el.querySelector('svg') || el, meta: meta, done: false });
  }

  /* Mesuré sur le SVG lui-même (le conteneur n'a pas de hauteur) : 0 quand son haut
     touche le bas de l'écran, 1 quand son bas est remonté à 55 % de la hauteur,
     donc le trait finit dans la moitié haute de l'écran, la section encore en vue. */
  function progress(rect, vh) {
    return Math.max(0, Math.min(1, (vh - rect.top) / (rect.height + vh * 0.45)));
  }

  function render() {
    ticking = false;
    var vh = window.innerHeight;
    var atEnd = window.scrollY + vh >= document.documentElement.scrollHeight - 2;
    items.forEach(function (it) {
      if (it.done) return;
      var p = atEnd ? 1 : progress(it.svg.getBoundingClientRect(), vh);
      it.meta.forEach(function (m) {
        var local = Math.max(0, Math.min(1, (p - m.a) / (m.b - m.a)));
        m.p.style.strokeDashoffset = m.l * (1 - local);
      });
      if (p >= 1) { it.done = true; it.el.classList.add('is-drawn'); }
    });
  }

  function schedule() { if (!ticking) { ticking = true; window.requestAnimationFrame(render); } }

  function init(root) {
    (root || document).querySelectorAll('.figure__drawing').forEach(setup);
    if (items.length) schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  init(document);
})();
